import type { ProductCatalogItem } from "@ozon-ai/ozon/contracts";
import type { ICellRendererParams } from 'ag-grid-community';
import { CatalogItemHoverPreview, CatalogItemThumbnail } from './catalog-item-hover-preview';

export function OfferIdCellRenderer(params: ICellRendererParams<PurchaseGridRow, string>) {
  const row = params.data;
  const offerId = params.value || row?.offerId || '';
  const catalog = (params.context?.catalog as ProductCatalogItem[] | undefined) || [];
  const item = catalog.find((entry) => entry.offerId === offerId);
  const title = item?.name || row?.productName || offerId || '—';

  return (
    <CatalogItemHoverPreview item={item} title={title}>
      <div className="flex h-full min-w-0 items-center gap-2 text-foreground">
        <CatalogItemThumbnail item={item} title={title} />
      </div>
    </CatalogItemHoverPreview>
  );
}

export interface PurchaseGridRow {
  id: string;
  offerId: string;
  ozonSku?: string;
  productName?: string;
  quantity: number;
  unitPriceRub: number;
  linePurchaseRub: number;
  unitPriceWithDeliveryRub: number;
}
